const regex = /<strong>(.*?)<\/strong>/gi; // Regex to match <strong> tags
export const replaceStrongTags = (value) => {
  return value?.replace(
  regex,
  "<span style='font-weight: bolder;'>$1</span>"
  );
}